jQuery(($) => {
    //mobile menu
    let lastScrollY = 0;

    const redBanner = document.querySelector(".header-red-banner__parent");

    function redbanner() {
        const ctabtns = document.querySelector(".hero__content .ctaButtons");

        const element = ctabtns.getBoundingClientRect().bottom + window.scrollY;

        if (window.scrollY > element) {
            redBanner.classList.add("fixed");
        } else {
            redBanner.classList.remove("fixed");
        }
    }

    //red banner on product page
    window.addEventListener("scroll", function () {
        if (redBanner) {
            redbanner();
        }
    });
    if (redBanner) {
        redbanner();
    }

    document.body.addEventListener("click", (event) => {
        const button = event.target.closest(".burger");
        const header = document.querySelector("header");
        const menuPage = document.getElementById("menuPage");
        const container = document.querySelector(".imgConatiner");

        if (button) {
            if (document.body.classList.contains("fixed")) {
                document.body.classList.remove("fixed");

                // Temporarily disable smooth scrolling
                document.documentElement.style.scrollBehavior = "auto";
                window.scrollTo(0, lastScrollY);
                document.documentElement.style.removeProperty(
                    "scroll-behavior"
                );
            } else {
                lastScrollY = window.scrollY;
                document.body.classList.add("fixed");
            }

            if (header.classList.contains("fixed")) {
                menuPage.style.top = "62px";
                container.style.height = `52px`;
            } else {
                menuPage.style.top = "100px";
                if (window.innerWidth < 768) {
                    menuPage.style.top = "70px";
                }
            }

            document.getElementById("menuPage").classList.toggle("active");
            button.classList.toggle("active"); // Add class to the clicked button
        }
    });

    document.body.addEventListener("click", (event) => {
        //for image menus
        const button = event.target;

        if (
            button.classList.contains("menu-item-has-children") &&
            window.innerWidth < 991
        ) {
            event.preventDefault();
            const subMenu = button.nextElementSibling;
            if (subMenu && subMenu.classList.contains("sub-menu")) {
                // Do something with the sub-menu, like toggling its visibility
                subMenu.classList.toggle("active");
            }
        }
    });

    // fixed navigation
    document.getElementById("menuPage").style.display = "flex";

    document.body.addEventListener("click", (event) => {
        const button = event.target.closest(".showSearch");
        if (button) {
            document
                .getElementById("magnifyingGlass")
                .classList.toggle("cross");
            event.preventDefault();
            button.classList.toggle("active"); // Add class to the clicked button
            document
                .querySelector(".mobileSearch__container")
                .classList.toggle("open");
        }
    });

    let originalWidth = 260;
    let startHeight = 85;

    const updateDimensions = () => {
        if (window.innerWidth < 1280) {
            originalWidth = 208;
            startHeight = 61;
        } else {
            originalWidth = 260;
            startHeight = 85;
        }
    };

    const checkScroll = () => {
        const menuPage = document.getElementById("menuPage");
        const header = document.querySelector("header");

        const main = document.querySelector("main");
        const container = document.querySelector(".imgConatiner");
        const img = document.querySelector(".siteLogo");
        const img2 = document.querySelector(".siteLogo2");
        const search = document.querySelector(".fixed-search");
        const mobileSearch__container = document.querySelector(
            ".mobileSearch__container"
        );

        if (!img) {
            console.error("Image inside #siteLogo not found!");
            return;
        }

        const scrollY = window.scrollY || window.pageYOffset;

        // Toggle classes for header and main
        if (!document.body.classList.contains("fixed")) {
            header.classList.toggle("fixed", scrollY > 62);
            main.classList.toggle("fixed", scrollY > 62);
        }

        // Update dynamic values based on screen size
        updateDimensions();

        const startScroll = 0,
            endScroll = 68;
        const endHeight = 52;

        // Calculate the new height
        const newHeight =
            scrollY >= endScroll
                ? endHeight
                : scrollY <= startScroll
                ? startHeight
                : startHeight -
                  (scrollY / endScroll) * (startHeight - endHeight);

        // Maintain the aspect ratio of the logo
        const newWidth = (newHeight / startHeight) * originalWidth;

        // Apply the new height and width to the image
        img2.style.display = `block`;

        if (window.innerWidth > 768) {
            container.style.height = `${newHeight}px`;
            container.style.width = `${newWidth}px`;
            if (scrollY > endScroll) {
                img.style.display = `none`;
                search.classList.add("open");
            } else {
                img.style.display = `block`;
                search.classList.remove("open");
                mobileSearch__container.classList.remove("open");
            }

            // Margin change logic for the image
            const startMargin = 30, // Initial margin in px
                endMargin = 5; // Final margin in px

            // Calculate the new margin
            const newMargin =
                scrollY >= endScroll
                    ? endMargin
                    : scrollY <= startScroll
                    ? startMargin
                    : startMargin -
                      (scrollY / endScroll) * (startMargin - endMargin);

            // Apply the new margin to the image
            container.style.marginBottom = `${newMargin}px`;
        }
    };

    // Run on page load in case user refreshes while scrolled down

    const container = document.querySelector(".imgConatiner");
    if (window.innerWidth > 768) {
        updateDimensions();
        checkScroll();
        // Listen for scroll events
        window.addEventListener("scroll", checkScroll);
    } else {
        // header.classList.add("fixed");
        container.style.marginBottom = `0px`;
    }

    // Listen for resize events to update dimensions dynamically
    window.addEventListener("resize", () => {
        if (window.innerWidth < 768) {
            window.removeEventListener("scroll", checkScroll);
            // header.classList.add("fixed");
            updateDimensions();
            // checkScroll();
            container.style.marginBottom = `0px`;
            container.style.height = `55px`;
            container.style.width = `170px`;
        } else {
            updateDimensions();
            checkScroll();
            // Listen for scroll events
            window.addEventListener("scroll", checkScroll);
        }
    });
});
